import Table from '@oncolens/oncolens-ui/lib/components/Common/Table';
import React from 'react';
import { FaPencilAlt } from 'react-icons/fa';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import { getOrganizationsWithSsoConnections } from '../api/organizations';
import { OrganizationFilters } from '@/features/organizations';
import { OrganizationDto } from '../types';

interface OrganizationsTableProps {
  filters: OrganizationFilters;
}

export const OrganizationsTable = ({ filters }: OrganizationsTableProps) => {
  const columns = React.useMemo(
    () => [
      { accessor: 'legacyLookups', Header: '', Cell: ActionsColumn },
      { accessor: 'id', Header: 'Id' },
      { accessor: 'name', Header: 'Name' },
      { accessor: 'ssoConnection', Header: 'SSO', Cell: SsoConnectionColumn },
      { accessor: 'referenceCode', Header: 'Reference Code' },
      {
        accessor: 'parentOrganization',
        Header: 'Parent Organization',
        Cell: ParentOrganizationColumn,
      },
    ],
    [],
  );

  const filtersDef = {
    ...(filters.search && { Filters: `(ReferenceCode|Name)@=*${filters.search}` }),
  };

  return (
    <Table
      columns={columns}
      fetchData={getOrganizationsWithSsoConnections(true)}
      queryBaseKey="organizations"
      additionalQueryParameters={filtersDef}
      options={{ textSize: 'sm' }}
    />
  );
};

interface OrgTableColumnProps {
  row: {
    original: OrganizationDto;
  };
}

const ParentOrganizationColumn = ({ row: { original: data } }: OrgTableColumnProps) => (
  <>{data.parentOrganization?.name ?? ''}</>
);

const SsoConnectionColumn = ({ row: { original: data } }: OrgTableColumnProps) => {
  const status = data.ssoIntegrationStatus ?? '';

  // eslint-disable-next-line eqeqeq
  return <>{status == 'Active' ? 'Yes' : 'No'}</>;
};

const ActionsColumn = ({ row: { original: data } }: OrgTableColumnProps) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/organizations/${data.id}`)}
      className="text-gray-600 hover:text-gray-800">
      <FaPencilAlt className="w-4 h-4" />
    </button>
  );
};
